<template>
  <div>
    <div class="cp-10">
      <v-text-field
        ref="New Password"
        v-model="newPassword"
        label="New Password"
        :type="showIcon2 ? 'password' : 'text'"
        :append-icon="showIcon2 ? 'visibility_off' : 'visibility'"
        @click:append="showIcon2 = !showIcon2"
        :error-messages="newPasswordCheck"
        class="input"
        required
      >
      </v-text-field>
    </div>
    <div class="cp-10">
      <v-text-field
        ref="Cofirm password"
        v-model="repeatPassword"
        label="Confirm New Password"
        :type="showIcon3 ? 'password' : 'text'"
        :append-icon="showIcon3 ? 'visibility_off' : 'visibility'"
        @click:append="showIcon3 = !showIcon3"
        :error-messages="repeatPasswordCheck"
        class="input"
        required
      >
      </v-text-field>
    </div>
    <div style="text-align: left; margin-top: 3.0rem">
      <div @click="submit" class="btn btn-save">
        Submit
      </div>
    </div>
  </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  sameAs
} from "vuelidate/lib/validators";
export default {
  name: "auth-password",
  data: function() {
    return {
      newPassword: "",
      repeatPassword: "",
      showIcon2: true,
      showIcon3: true
    };
  },
  validations: {
    newPassword: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(12)
    },
    repeatPassword: {
      required,
      sameAs: sameAs("newPassword")
    }
  },
  methods: {
    submit: function() {
      const self = this;
      self.$v.$touch();
      let changedPassword = {
        password: self.newPassword
      };
      if (!self.$v.$anyError) {
        self.$emit("change-password", changedPassword);
      }
    }
  },
  computed: {
    newPasswordCheck: function() {
      const errors = [];
      if (!this.$v.newPassword.$dirty) return errors;
      !this.$v.newPassword.required &&
        errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
      !this.$v.newPassword.maxLength &&
        errors.push(this.$constants.REQUIRED_MESSAGE.PASSWORD_LENGTH);
      !this.$v.newPassword.minLength &&
        errors.push(this.$constants.REQUIRED_MESSAGE.PASSWORD_LENGTH);

      return errors;
    },
    repeatPasswordCheck: function() {
      const errors = [];
      if (!this.$v.repeatPassword.$dirty) return errors;
      !this.$v.repeatPassword.required &&
        errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
      !this.$v.repeatPassword.sameAs &&
        errors.push(this.$constants.REQUIRED_MESSAGE.PASSWORD_NOT_MATCH);
      return errors;
    }
  }
};
</script>

<style scoped>
.cp-10 {
  padding: 0.5rem 0;
}
.input {
  text-align: right;
  font-size: 1.4rem;
}
</style>
